import * as Yup from "yup";
import logCashPaymentModel from "../models/logCashPaymentModel";

const {
  formField: {
    client,
    property,
    amount,
    receiptNumber,
    purpose,
    internetPackageId,
    paymentMethod
  },
} = logCashPaymentModel;

const logCashPaymentSchema = Yup.object().shape({
  client: Yup.string().required(client.requiredErrorMsg),
  property: Yup.string().required(property.requiredErrorMsg),
  amount: Yup.number()
    .typeError(amount.invalidErrorMsg)
    .positive(amount.invalidErrorMsg)
    .required(amount.requiredErrorMsg),
  receiptNumber: Yup.string().required(receiptNumber.requiredErrorMsg),
  purpose: Yup.string().required(purpose.requiredErrorMsg),
  internetPackageId: Yup.string().when("purpose", {
    is: "internet",
    then: (schema) => schema.required(internetPackageId.requiredErrorMsg),
    otherwise: (schema) => schema.notRequired(),
  }),
  paymentMethod: Yup.string().required(paymentMethod.requiredErrorMsg),
  paymentDate: Yup.date().required("Payment date is required"),
});

export default logCashPaymentSchema;
